import { format, utcToZonedTime, OptionsWithTZ } from 'date-fns-tz';
import sv from 'date-fns/locale/sv';

export const defaultTimeZone = 'Europe/Stockholm';

/**
 * Format a localised date
 * @see https://date-fns.org/v2.16.1/docs/Time-Zones
 * @see https://date-fns.org/v2.16.1/docs/format
 *
 * @param string date     the input date to parse
 * @param string locale   the locale to format the date for
 * @param object options  options forwarded to "toLocaleDateString"
 *
 * @return string
 */
export const formatDate = (
  date: string | number | Date,
  timeZone: string = defaultTimeZone,
  pattern = 'P', // localized Date format
  formatOptions: OptionsWithTZ = {
    locale: sv
  }
): string => {
  const zonedDate = utcToZonedTime(new Date(date).toISOString(), timeZone);

  return format(zonedDate, pattern, { ...formatOptions, timeZone });
};

/**
 * Format a localised time
 * @see https://date-fns.org/v2.16.1/docs/Time-Zones
 * @see https://date-fns.org/v2.16.1/docs/format
 *
 * @param string date     the input date to parse
 * @param string locale   the locale to format the date for
 * @param object options  options forwarded to "toLocaleTimeString"
 *
 * @return string
 */
export const formatTime = (
  date: string | number | Date,
  timeZone: string = defaultTimeZone,
  pattern = 'p', // localized Time format
  formatOptions: OptionsWithTZ = {
    locale: sv
  }
): string => {
  const zonedDate = utcToZonedTime(new Date(date).toISOString(), timeZone);

  return format(zonedDate, pattern, { ...formatOptions, timeZone });
};
